$(function () {  
  // Remove controls from the video element
  $(".home_top_vdo_wrapper video").removeAttr("controls");

  $(".custom-tab-link").on("click", function () {
    var target = $(this).data("tab");
    $(".custom-tab-link").removeClass("active");
    $(this).addClass("active");
    $(".custom-tab-content").removeClass("active");
    $(target).addClass("active");
  });

  // Add Lazy Load in Image Tags
  $("main img").each(function () {
    if (!$(this).attr("loading")) {
      $(this).attr("loading", "lazy");
    }
  });

  $("p, div").each(function () {
    const validChildren = $(this)
      .contents()
      .filter(function () {
        // Remove elements OR non-empty text nodes excluding just whitespace and &nbsp;
        if (this.nodeType === 3) {
          const text = this.textContent.replace(/\u00A0/g, "").trim();
          return text !== "";
        }
        return true; // keep elements
      });

    const allImages =
      validChildren.length > 0 &&
      validChildren.get().every(function (el) {
        return el.nodeType === 1 && el.tagName.toLowerCase() === "img";
      });

    if (allImages) {
      $(this).addClass("image_wrapper");
    }
  });

  // Iframe Wrapper Class
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  $(iframeSelectors).each(function () {
    // Only wrap if not already wrapped
    if (!$(this).parent().hasClass("video-wrapper")) {
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });

  // Hide Empty p
  $(".template-instructions .copper-page-wrapper p").each(function () {
    const $p = $(this);

    // If empty or contains only whitespace
    if ($p.text().trim() === "" && $p.children().length === 0) {
      $p.css({ display: "none", margin: 0 });
    }

    // If it only has a `<br>` or similar
    else if ($p.contents().length === 1 && $p.contents().first().is("br")) {
      $p.css({ display: "none", margin: 0 });
    }
  });

  // Custom DropDown Element

  $(document).on("click", ".sprout-custom-dropdown .dropdown-toggle", function (e) {
      e.stopPropagation();

      const $toggle = $(this);
      const $menu = $toggle.next(".dropdown-menu");

      if ($menu.is(":visible")) {
        $menu.hide();
        $toggle.removeClass("active");
      } else {
        $(".dropdown-menu").hide();
        $(".dropdown-toggle").removeClass("active");

        $menu.show();
        $toggle.addClass("active");
      }
    });
  
  $(document).on("click", function (e) {
    // If click is outside the dropdown and not on the toggle
    if (!$(e.target).closest(".sprout-custom-dropdown").length) {
      $(".dropdown-menu").hide();
      $(".dropdown-toggle").removeClass("active");
    }
  });

  const headerEl = document.querySelector("header-component#header-component");

    // To handle Fancy FAQ Pages
  $(".dtfq-toggle-content").hide();

  // Click handler for title
  $(".dtfq-toggle-title").on("click", function () {
    var content = $(this).next(".dtfq-toggle-content");

    // Accordion behavior: collapse all, then expand the clicked one
    $(".dtfq-toggle-content").not(content).slideUp();
    content.slideToggle();

    // Optionally toggle a class on the icon or title
    $(".dtfq-toggle-title").not(this).removeClass("active");
    $(this).toggleClass("active");
  });

$('.form-group').each(function() {
  const html = $(this).html().trim();
  if (html === '' || html === '<br>' || html === '<br/>' || html === '<br />') {
    $(this).hide();
  }
});



});

AOS.init();

//   window.addEventListener('load', () => {
//   AOS.refresh();
// });

document.querySelectorAll('img[loading="lazy"]').forEach(img => {
  img.addEventListener('load', () => {
    AOS.refresh();
  });
});

// members-testimonial-slider
const slideCount = document.querySelectorAll(
  ".swiper-container .swiper-slide"
).length;

const swiper = new Swiper(".members-testimonial-slider", {
  loop: slideCount > 2,
  spaceBetween: 30,
  slidesPerView: 1, // Default: 1 slide on mobile

  breakpoints: {
    768: {
      slidesPerView: 2, // Show 2 slides from 768px and above
    },
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

// faq section start
$(document).ready(function () {
  $(".faq-question").click(function () {
    // Close others
    $(".faq-question")
      .not(this)
      .removeClass("active")
      .next(".faq-answer")
      .slideUp(200);

    // Toggle current
    $(this).toggleClass("active").next(".faq-answer").slideToggle(200);
  });
});



// 
const toggle = document.querySelector('.facets-toggle__wrapper');
const close = document.querySelector('.facets-drawer__close');
const dialog = document.querySelector('dialog-component dialog');

function removeDrawer() {
  document.body.classList.remove('drawer-open');
  document.documentElement.classList.remove('drawer-open'); // <html> se bhi
  document.removeEventListener('click', handleOutsideClick);
}

function handleOutsideClick(e) {
  if (!dialog.contains(e.target) && !toggle.contains(e.target)) {
    removeDrawer();
  }
}

toggle?.addEventListener('click', () => {
  document.body.classList.add('drawer-open');
  document.documentElement.classList.add('drawer-open');
  setTimeout(() => document.addEventListener('click', handleOutsideClick));
});

close?.addEventListener('click', removeDrawer);

dialog?.addEventListener('click', e => {
  if (e.target === dialog) removeDrawer();
});


